const local = '_POLICE_SESSION_CLIENTE_'
const localSistema = '_POLICE_SESSION_CLIENTE_SISTEMA_'

export default {
	set(cliente) {
		var string = JSON.stringify(cliente)
		sessionStorage.setItem(local, string)
	},

	get(posicao) {
		// se existir config do cliente
		if (sessionStorage.getItem(local) != null) {
			var cliente = JSON.parse(sessionStorage.getItem(local))
			return window._.isNil(posicao) ? cliente : cliente[posicao]
		} else {
			return null
		}
	},

	setVersao(versao) {
		var string = JSON.stringify(versao)
		sessionStorage.setItem(localSistema, string)
	},

	getModulo(moduloId) {
		var modulos = this.getVersao('modulo')

		for (var i = 0, t = modulos.length; i < t; i++) {
			if (modulos[i].id_modulo == moduloId) {
				return true
			}
		}

		return false
	},

	getVersao(posicao) {
		// se existir config do cliente
		if (sessionStorage.getItem(localSistema) != null) {
			var versao = JSON.parse(sessionStorage.getItem(localSistema))
			return window._.isNil(posicao) ? versao : versao[posicao]
		} else {
			return null
		}
	}
}
